import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { POP_UP_CONTAINER_ID } from '../../../../constans/index';
import styles from './styles.module.scss';

import cn from 'classnames';

function PopUp({ clickOutside = true, closeImg = true, close = () => { }, children, ...props }) {
  const [field, setField] = useState(document.getElementById(POP_UP_CONTAINER_ID));
  useEffect(() => {
    const onKeyPressed = e => {
      if (e.keyCode === 27 && clickOutside) {
        close();
      }
    };

    document.addEventListener('keydown', onKeyPressed);
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('keydown', onKeyPressed);
    };
  }, [props, clickOutside, close]);

  function clickClose() {
    if (clickOutside) {
      close();
    }
  }

  useEffect(
    () => setField(document.getElementById(POP_UP_CONTAINER_ID)),
    [document.getElementById(POP_UP_CONTAINER_ID)],
  );

  return (
    field &&
    ReactDOM.createPortal(
      <div className={styles.popUpBackground} onClick={clickClose}>
        <div className={cn(styles.popUp,)} onClick={e => e.stopPropagation()}>
          {closeImg && <div className={styles.popUpClose} onClick={() => close()} />}
          <div className={cn(styles.popupContent, props.className)} style={props.style}>
            {children}
          </div>
        </div>
      </div>
      ,
      field,
    )
  );
}


export default PopUp;
